import "./App.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import Home from "./components/Home";
import SessionList from "./components/SessionList";
import Session from "./components/Session";
import SessionCreate from "./components/SessionCreate";
import ProtectedRoute from "./auth/protected-route";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact children={<Home />} />
        <ProtectedRoute
          path="/session/create"
          exact
          component={SessionCreate}
        />

        <ProtectedRoute path="/session/:id" exact component={Session} />
        <ProtectedRoute path="/session" exact component={SessionList} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
